import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { FC, PropsWithChildren, useState } from "react";

export interface CollapsiblePanelProps extends PropsWithChildren {
  isOpen: boolean;
  className?: string;
}

export const CollapsiblePanel: FC<CollapsiblePanelProps> = ({ isOpen, className, children }) => {
  const [stable, setStable] = useState(true);

  return (
    <div className={className}>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            className={clsx({ "overflow-hidden": !stable })}
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            onAnimationStart={() => setStable(false)}
            onAnimationComplete={() => setStable(true)}
            variants={{
              open: { opacity: 1, height: "auto", overflow: "visible" },
              collapsed: { opacity: 0, height: 0, overflow: "hidden" },
            }}
            transition={{ ease: "easeOut", duration: 0.2 }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
